export const SUBSCRIBE_USER_START = 'SUBSCRIBE_USER_START';
export const UPDATE_SUBSCRIPTION_START = 'UPDATE_SUBSCRIPTION_START';
export const SUBSCRIBE_USER_COMPLETE = 'SUBSCRIBE_USER_COMPLETE';
